<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="xl" ref="biddersModal" :visible="modal.show" :data="model" :title="computedTitle"
                   @show="onShow" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)"
                   :content-in-form="false"
                   :show-confirmation="showConfirmation" :ok-title="$t('Submit')"
                   :is-loading="loading" scrollable>
      <div class="row">
        <div :class="model.isReleased() ? 'col-xl-12' : 'col-xl-8 col-sm-12 border-right'">
          <div class="row" v-if="errorMessage">
            <div class="col-md-12">
              <b-alert variant="danger" show>
                {{ errorMessage }}
              </b-alert>
            </div>
          </div>
          <div v-if="model.activeTab === 0">
            <input-widget :model="model" attribute="title" :readonly="model.isReleased()" />
            <input-widget :model="model" attribute="body" type="ckeditor" :disabled="model.isReleased()" :ck-editor="ckEditorConfig" />
            <input-widget :model="model" attribute="internal_note" type="ckeditor" />
            <template v-if="model.isReleased()">
              <input-widget :model="model" attribute="version" :readonly="model.isReleased()" />
              <input-widget :model="model" attribute="version_suffix" :readonly="model.isReleased()" />
              <input-widget :model="model" attribute="publish_on_website" type="checkbox" v-permission="'publish_conditionreport'" />
            </template>
          </div>
          <div v-if="model.activeTab === 1">
            <input-widget :model="model" attribute="version" :readonly="model.isReleased()" />
            <input-widget :model="model" attribute="version_suffix" :readonly="model.isReleased()" />
            <input-widget :model="model" attribute="send_to_all" type="checkbox" :hint="true" v-if="$hasPermission('export_conditionreport')" />
            <input-widget :model="model" attribute="publish_on_website" type="checkbox" v-if="$hasPermission('publish_conditionreport')" />
          </div>
          </div>
              <template v-if="model.activeTab !== 1 && !model.isReleased()">
                <div class="col-xl-4 col-sm-12">
                    <file-uploader :show-preview="true"
                                   :disable-image-drag-upload="false"
                                   :is-draggable="false"
                                   :items-prop="files" :hint-text="false"
                                   :accept="fileUploaderAccept"
                                   :enable-image-resize="true"
                                   :limit-upload-number="conditionReportImagesMaxAttachmentCount"
                                   ref="fileUploader"/>
                </div>
              </template>
        </div>
      <template v-slot:modal-footer>
        <cancel-button @click="hideModal" :disabled="loading">
          {{ $t('Cancel') }}
        </cancel-button>
        <template v-if="model.activeTab === 0">
          <submit-button v-if="!model.uuid || model.isDraft()" @click="onDraftSubmit" :disabled="loading" :show-loader="loading">
            {{ $t('Save as Draft') }}
          </submit-button>
          <submit-button v-if="model.uuid && model.isReleased()" @click="onSubmit()" :disabled="loading" :show-loader="loading">
            {{ $t('Save') }}
          </submit-button>
          <submit-button v-else @click="showReleaseDetails()" :disabled="loading" :show-loader="loading">
            {{ $t('Release Version') }}
          </submit-button>
        </template>
        <template v-if="model.activeTab === 1">
          <submit-button v-if="!model.uuid || model.isDraft()" @click="onDraftSubmit" :disabled="loading" :show-loader="loading">
            {{ $t('Save as Draft') }}
          </submit-button>
          <submit-button @click="onSubmit()" :disabled="loading" :show-loader="loading">
            {{ $t('Submit') }}
          </submit-button>
        </template>
      </template>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import InputWidget from "../../core/components/input-widget/InputWidget";
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import ConditionReportModel from "./ConditionReport.model";
  import ConditionReportsModel from "./ConditionReport.model";
  import SubmitButton from "@/core/components/common/SubmitButton.vue";
  import CancelButton from "@/core/components/common/CancelButton.vue";
  import ConditionReportsService from "@/modules/condition-reports/ConditionReportsService";
  import FileUploader from "@/core/components/file-uploader/FileUploader.vue";
  import ConditionReportImagesService from "@/modules/condition-report-images/ConditionReportImagesService";

  const {mapState, mapActions} = createNamespacedHelpers('conditionReports');
  const {mapState: globalMapSate} = createNamespacedHelpers('global');

  export default {
    name: "ConditionReportsModal",
    components: {
      FileUploader,
      CancelButton, SubmitButton,
      InputWidget,
      ArtisioModal
    },
    data() {
      return {
        activeTab: 0,
        loading: false,
        showConfirmation: true,
        credit_limit_checked: false,
        model: new ConditionReportModel(),
        errorMessage: null,
        isFirst: true,
        showHint: true,
        oldStatus: null,
        files: [],
        ckEditorConfig: {
          // editor: InlineEditor,
          // editorData: '',
          // editorConfig: {
          //   toolbar: [ 'undo', 'redo', 'bold', 'italic', 'numberedList', 'bulletedList' ]
          // }
        }
      }
    },
    computed: {
      ...mapState({
        statuses: state => state.statuses,
        modal: state => state.modal,
        editObject: state => state.modal.object
      }),
      ...globalMapSate([
        'attachmentMaxFileSize',
        'imageFileFormats',
        'conditionReportImagesMaxAttachmentCount',
        'conditionReportImagesAttachmentSizeSum'
      ]),
      fileUploaderAccept() {
        return [{formats: this.imageFileFormats, size: this.attachmentMaxFileSize}]
      },
      computedTitle() {
        if (this.model.activeTab === 1) {
          return this.$i18n.t(`Release a new version for "{title}"`, {title: this.model.title})
        }
        if (this.model.uuid) {
          return this.$i18n.t('Update Condition Report')
        } else {
          return this.$i18n.t('New Condition Report')
        }
      },
    },
    watch: {
      async editObject() {
        if (this.editObject && (this.editObject.uuid || this.editObject.inventory_uuid)) {
          this.model = new ConditionReportsModel(this.editObject);
        }
      },
    },
    methods: {
      ...mapActions(['hideModal', 'createConditionReport', 'updateConditionReport']),
      async onShow() {
        if (!this.editObject || !this.editObject.uuid) {
          this.model.title = `Condition Report for item ${this.editObject.inventory.stock_no} - ${this.$options.filters.currentDate()}.pdf`
        }
        await this.getImagesForConditionReport()
        this.showConfirmation = true;
      },
      onHidden() {
        this.model = new ConditionReportsModel();
        this.isFirst = true;
        this.hideModal();
        this.loading = false;
        this.errorMessage = null;
        this.showHint = true;
        this.clearData();
      },
      async getImagesForConditionReport(){
        if (this.model.uuid) {
          let response = await ConditionReportImagesService.getConditionReportImages(this.editObject.uuid, 'created_by', '');
          if (response.success) {
            this.files = response.body.map(item => {
              const { file, ...remainingItem } = item;
              return remainingItem;
            });
          }
        }
      },
      async onDraftSubmit(afterSubmit = true) {
        return this.submitForm('draft', afterSubmit);
      },
      async onSubmit(afterSubmit = true) {
        return this.submitForm('released', afterSubmit);
      },
      async showReleaseDetails() {
        const success = await this.onDraftSubmit(false);
        if (success) {
          this.model.activeTab = 1;
          if (!this.model.version) {
            const response = await ConditionReportsService.getNextVersion(this.model.inventory_uuid)
            this.model.version = response.body.version ? parseInt(response.body.version) + 1 : 1
          }
        }
      },
      async submitForm(status, afterSubmit = true) {
        const formData = this.getFiles();
        if (!formData) {
          return;
        }
        let response;
        this.loading = true;

        if (!this.model.inventory_uuid && this.modal.object.inventory) {
          this.model.inventory_uuid = this.modal.object.inventory.uuid;
        }

        const payload = {
          ...this.model.toJSON(),
          status,
          to_be_deleted: this.files
              .filter(file => file.to_be_deleted)
              .map(file => file.uuid),
        }
        Object.keys(payload).forEach(key => {
          if (typeof payload[key] === 'boolean') {
            formData.append(key, payload[key]);
          } else {
            formData.append(key, payload[key] ? payload[key] : '');
          }
        });

        if (!this.model.uuid) {
          formData.append('created_manually', 'true');
          response = await this.createConditionReport(formData);
        } else {
          response = await this.updateConditionReport(formData);
        }
        if (response.success) {
          this.model.status = status
          if (!this.model.uuid) {
            this.model.uuid = response.body.uuid;
          }
          this.clearData();
        } else {
          this.model.errors = response.response.data;
        }
        if (response.body && response.body.invalid_images && response.body.invalid_images.length > 0) {

            let nonImageFiles = response.body.invalid_images;
            if (typeof nonImageFiles === 'string') {
              nonImageFiles = nonImageFiles.split('\n');
            }

            const listItems = nonImageFiles.map((file, index) => {
              return this.$createElement('li', { class: 'non-image-file' }, file);
            });

            const ulElement = this.$createElement('ul', { class: 'mb-0' }, listItems);

            const container = this.$createElement('div', { class: 'non-image-container' }, [
              this.$createElement('h5', { class: 'mb-0' }, 'Invalid image(s) provided for report'),
              ulElement,
            ]);

            this.$errorDialog(container, this.$i18n.t('Image Validation Error'));
            this.clearData();
            this.model.errors = response.response.data
          }

        this.loading = false;

        if (afterSubmit) {
          this.afterSubmit(response)
        }
        return response.success
      },
      getFiles() {
        let formData = new FormData();
        this.files.forEach(item => {
          if (item.file) {
            formData.append('file', item.file);
          }
        });
        return formData;
      },
      afterSubmit(response) {
        if (response.success) {
          this.showConfirmation = false;
          this.hideModal();
          if (!this.model.uuid) {
            this.$toast('success', this.$t('Condition Report was successfully created'));
          } else {
            if (response.body && !response.body.invalid_images){
              this.$toast('success', this.$t('Condition Report was successfully updated'));
            }
          }
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else {
            if (response.body.status) {
              this.showHint = false
            }
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      clearData() {
        this.files = [];
        if (this.$refs.fileUploader){
          this.$refs.fileUploader.clearInput();
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
 /deep/ .ck-editor__editable {
   min-height: 200px;
 }
</style>
